export const customFilterChipRender = (
  filterList: string[][],
  filterPos: number,
  index: number
): string[][] => {
  filterList[index].splice(filterPos, 1);
  return filterList;
};
